import { compareValues, personName } from '../components/SortableTable';

/** Patients A-Z by last name, then first name (case/accent-insensitive). Returns a new array. */
export const sortPatientsAZ = (patients) =>
    [...(patients || [])].filter(Boolean).sort((a, b) => compareValues(personName(a), personName(b), 'name'));

/** "Last, First" display label used by patient pickers. */
export const patientLabel = (p) => [p && p.lastname, p && p.firstname].filter(Boolean).join(', ');
